import { Radio as MuiRadio, type RadioProps as MuiRadioProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiRadioProps, 'slots' | 'icon' | 'checkedIcon'>>;

export function Radio(props: Props) {
  return <MuiRadio {...props} />;
}

export type { Props as RadioProps };
